const Heart = ({ className }: { className?: string }) => (
    <svg
        width="138"
        height="139"
        className={className}
        viewBox="0 0 138 139"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M69.124 121.499C85.9589 103.402 118.653 81.1751 126.941 55.4064C128.179 51.5583 128.549 47.5196 128.027 43.5364C127.506 39.5533 126.104 35.7091 123.908 32.238C121.712 28.7668 118.768 25.7415 115.254 23.3463C111.74 20.951 107.73 19.236 103.469 18.3057C99.2085 17.3754 94.7854 17.2492 90.4696 17.935C86.1537 18.6207 82.0355 20.104 78.3657 22.2944C74.696 24.4848 71.5516 27.3365 69.124 30.6758"
            stroke="#F3CBE7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M37.2705 65.082H53.1988L62.7558 45.968L75.4984 84.1959L85.0554 65.082H100.984"
            stroke="#F3CBE7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M69.1217 121.5C52.2916 103.409 19.5885 81.1769 11.3117 55.4093C10.076 51.5621 9.70809 47.5248 10.2304 43.5432C10.7527 39.5616 12.1544 35.719 14.35 32.2494C16.5456 28.7797 19.4893 25.7556 23.0018 23.3611C26.5143 20.9665 30.5222 19.2518 34.7814 18.3211C39.0407 17.3904 43.4622 17.2633 47.7767 17.9475C52.0913 18.6317 56.2087 20.113 59.8783 22.301C63.5479 24.4891 66.6928 27.3382 69.1217 30.6749"
            stroke="#F3CBE7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Heart;
